import {
    Box,
    Button, Fab, Grid, IconButton, SwipeableDrawer, TextField,
    ThemeProvider,
    Typography,
    createTheme
  } from "@mui/material";
  import TrainingIcon from '@mui/icons-material/AutoStories';
  import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SupportIcon from '@mui/icons-material/ContactSupport';
import AddIcon from '@mui/icons-material/Add';
import ActionButton from "./ActionButton";
import ConfirmDialog, { confirmDialog } from "./ConfirmDialog";
 

    type ActionMenuProps= {
      buttons:any
    }


export default function ActionMenu(props:ActionMenuProps) {
const {buttons} = props
   
  

  
 
  

const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
      });


const darkTheme = createTheme({
        palette: {
          mode: 'dark',
          primary: {
            main: '#89B219',
          },
        },
      });
      
      type Anchor = 'top' | 'left' | 'bottom' | 'right';

      const [activeStep, setActiveStep] = React.useState(0);


     
  const [helpOpen, setHelpOpen] = React.useState(false);
  const [nextOpen, setNextOpen] = React.useState(false);

  

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };

  const handleNextOpen = () => {
    setNextOpen(true);
  };

  const handleNextClose = () => {
    setNextOpen(false);
  };


 


      const list = (anchor: Anchor) => (
        <Box
          sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 350, height: anchor === 'top' || anchor === 'bottom' ? '50%' : 500 }}
          role="presentation"
          onClick={toggleDrawer(anchor, false)}
          onKeyDown={toggleDrawer(anchor, false)}
    
        >
          <Grid container spacing={0}>
            <Grid item xs={9}>
              <Typography variant='h5' m={2}>Action Menu</Typography>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                size="large"
                aria-label="show more"
                aria-haspopup="true"
                onClick={handleClickHelpOpen}
                color="inherit"
              >
                <SupportIcon sx={{ fontSize: '50px' }} />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container spacing={1} padding={2}>
            <Grid item xs={12}>
            {buttons.map((button:any) => {
          return (
            <Grid key={button.props.buttonLabel} xs={12} >
              {button}
            </Grid>
          );
        })}
              {/* <Button startIcon={<AddCircleIcon style={{width:'35px', height: '35px'}} />} variant="contained" color="primary" fullWidth sx={{ height: '150px' }} onClick={() => { setActiveStep(0); handleClickOpen() }}>
                <Typography variant="h5" color="#FFF" textAlign="left" fontWeight={600}>New Patching List</Typography>
              </Button> */}
            </Grid>
          </Grid>
        </Box>
      );

      const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event &&
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }

        setState({ ...state, [anchor]: open });
      };

  
  return(
    <div>{ 
      
    (['right'] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <Fab color='success' onClick={toggleDrawer(anchor, true)} sx={{
            margin: 0,
            top: 'auto',
            right: 50,
            bottom: 65,
            left: 'auto',
            position: 'fixed',
          }}><AddIcon /></Fab>

          <ThemeProvider theme={darkTheme}>
            <SwipeableDrawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
              sx={{ bottom: '0', height: '50%' }}

            >
              {list(anchor)}
            </SwipeableDrawer>
          </ThemeProvider>
        </React.Fragment>
      ))
      }</div>
  );
  };
